import request from '@/utils/request'

// 手机号登录
export function loginByPhone(params) {
    return request({
        url: `/tour-product/wxuser/loginByPhone`,
        method: 'POST',
        params
    })
}

// 老用户优惠券
export function queryOldLists(data) {
    return request({
        url: `/tour-product/userCouponManage/queryOldLists`,
        method: 'post',
        data
    })
}

// 判断是新用户还是老用户，老用户返回token
export function getUserToken(params) {
    return request({
        url: `/tour-product/userCouponManage/getUserToken`,
        method: 'post',
        params
    })
}



